import { fetchApi } from 'api/index'

export const changeLanguageApi = (value) =>
  fetchApi(`/settings/language/${value}`, {
    method: 'POST',
  })
